import React from 'react';
import './List.less';

interface Props {
  children: React.ReactNode;
}

export default function ListItemIcon({ children }: Props) {
  return <div className="base-list__item-icon">{children}</div>;
}
